import { type FC, useCallback } from "react";

import { Fonts, Modal } from "@snapchat/snap-design-system";

import {
    UnsavedChangesActionText,
    UnsavedChangesBody,
    UnsavedChangesCancelText,
    UnsavedChangesTitle,
} from "../lens-source/messages.generated";

interface DiscardChangesModalProps {
    opened: boolean;
    onClose: () => void;
    onDiscard: () => void;
}

export const DiscardChangesModal: FC<DiscardChangesModalProps> = ({ opened, onClose, onDiscard }) => {
    const handleDiscard = useCallback(() => {
        onDiscard();
    }, [onDiscard]);

    return (
        <Modal
            visible={opened}
            onCancel={onClose}
            actionText={<UnsavedChangesActionText />}
            cancelText={<UnsavedChangesCancelText />}
            onAction={handleDiscard}
            data-testid="discard-changes-modal"
            title={<UnsavedChangesTitle />}
        >
            <span style={Fonts.Paragraph.P200}>{<UnsavedChangesBody />}</span>
        </Modal>
    );
};
